import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import SEOHead from "./components/SEOHead";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import HowWeWork from "./pages/HowWeWork";
import Industries from "./pages/Industries";
import CaseStudies from "./pages/CaseStudies";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <SEOHead />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        {/* WhatsApp floating button - Replace with your actual WhatsApp number */}
        <WhatsAppButton 
          phoneNumber="971544785924" 
          message="Hi, I'm interested in AiFlo.ai enterprise services. I'd like to discuss my requirements."
        />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
